export default "__VITE_ASSET__2523175e__"